import { AddCircle32Filled } from '@fluentui/react-icons';

import type { ButtonProps } from '../../atoms/button';
import { Button } from '../../atoms/button';

export type QuickStartCardProps = ButtonProps;

export const QuickStartCard = (props: QuickStartCardProps) => {
  return (
    <div className="text-primary-500 flex h-52 w-60 items-center justify-center rounded border border-gray-300 bg-white p-5">
      <Button
        {...props}
        className="flex flex-col items-center justify-center gap-2 text-xl"
        variant="text"
      >
        <AddCircle32Filled className="text-primary" />
        <span>Quick Start</span>
      </Button>
    </div>
  );
};
